import { create } from 'zustand';
import { useChatValidationStore } from '../chat';
import { getFixedT } from 'i18next';
import { FaqResponse, getFaqApi } from 'src/api';

type FaqStore = {
  open: boolean;
  loading: boolean;
  error: string;
  faq: FaqResponse | null;
  togglePanel: () => void;
  fetchFaq: () => Promise<void>;
};

const useFaqStore = create<FaqStore>((set) => ({
  open: false,
  loading: false,
  error: '',
  faq: null,
  togglePanel: () => set((state) => ({ open: !state.open })),
  fetchFaq: async () => {
    set({ loading: true, error: '' });
    try {
      const response = await getFaqApi({
        chatToken: useChatValidationStore.getState().token!,
      });
      set({ faq: response.data.FAQs });
    } catch (error) {
      set({ error: getFixedT(null, 'misc')('faq.error') });
    }
    set({ loading: false });
  },
}));

export { useFaqStore };
